import React from "react";
import HeaderOne from "../components/HeaderOne";
import { Helmet } from "react-helmet-async";
import FooterAreaOne from "../components/FooterAreaOne";
import Breadcrumb from "../components/Breadcrumb";
import SubscribeOne from "../components/SubscribeOne";
import Preloader from "../helper/Preloader";
import useInitialLoad from "../helper/useInitialLoad";
import MantenimientoServicesData from "../components/MantenimientoServicesData";

const MantenimientoServicePage = () => {
  const showPreloader = useInitialLoad(2000);

  return (
    <>
      {/* Preloader */}
      {showPreloader && <Preloader />}

      {/* Header one */}
      <HeaderOne />

      <Helmet>
        <title>Mantenimiento Coche Sevilla | Revisiones, ITV, Cambio Aceite | Leal</title>
        <meta name="description" content="Mantenimiento de vehículos en Sevilla y Mairena del Aljarafe. Revisiones, Pre-ITV, cambio aceite, filtros, neumáticos, aire acondicionado. Servicio rápido. Presupuesto gratis." />
        <meta name="keywords" content="mantenimiento coche Sevilla, revisión vehículo, Pre-ITV Mairena, cambio aceite Sevilla, filtros aire aceite, neumáticos taller, aire acondicionado coche, pulido faros Sevilla, limpieza interior" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Mantenimiento Coche Sevilla | Revisiones y Pre-ITV" />
        <meta property="og:description" content="Mantenimiento de vehículos en Mairena del Aljarafe. Revisiones, ITV, cambio aceite, neumáticos, aire acondicionado. Servicio rápido." />
        <meta property="og:url" content="https://www.lealchapaypintura.com/mantenimiento" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="es_ES" />
        <meta property="og:image" content="https://www.lealchapaypintura.com/favicon.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Mantenimiento Coche Sevilla | Revisiones y Pre-ITV" />
        <meta name="twitter:description" content="Revisiones, Pre-ITV, cambio aceite, neumáticos. Servicio rápido en Sevilla." />
        <meta name="twitter:image" content="https://www.lealchapaypintura.com/favicon.png" />
        <link rel="canonical" href="https://www.lealchapaypintura.com/mantenimiento" />
      </Helmet>

      {/* Breadcrumb */}
      <Breadcrumb
        title="Mantenimiento"
        parents={[{ label: "Servicios", path: "/#servicios" }]}
      />

      {/* Service Area One */}
      <MantenimientoServicesData title={"Mantenimiento"} />

      {/* Subscribe One */}
      <SubscribeOne />

      {/* Footer Area One */}
      <FooterAreaOne />
    </>
  );
};

export default MantenimientoServicePage;
